<template>
	<div>
		<div class="wrap"></div>
	</div>
</template>
<style scoped>
	.wrap {
		position: fixed;
		left: 50%;
		top: 50%;
		background: rgba(0, 0, 0, .35);
		padding: 10px;
		border-radius: 5px;
		transform: translate(-50%, -50%);
		color: #fff;
		z-index: 9999;
		display: none;
	}
</style>
<script>
	const apiUrl="http://xxxxxx.iscoser.com";
	
	export default {
		name: 'toast',
		data: function() {
			return {
				apiUrl
				
			}
		},
	}
</script>

